module.exports = __webpack_public_path__ + "static/media/logo-uppsala@2x.fbf0adde.png";